var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box-model',{attrs:{"title":"科技服务信息"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"scroll-text-container"},[_c('div',{staticClass:"scroll-text"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }